import { styled } from '@grupoboticario/flora';
import { FloraButton } from '@grupoboticario/flora-react';
import { theme } from 'ui/theme';

export const ModalStyles = {
  ButtonBack: styled(FloraButton, {
    '&[data-button-back-modal]': {
      borderColor: `${theme.colors.action.navigation.standard.static}`,
      color: `${theme.colors.action.navigation.standard.static}`,
      '&:hover': {
        background: `${theme.colors.action.navigation.standard.static}`,
        color: `${theme.colors.build.lightLight}`,
      },
    },
  }),

  ButtonNext: styled(FloraButton, {
    '&[data-button-next-modal]': {
      background: `${theme.colors.action.navigation.standard.static}`,
      '&:hover': {
        background: `${theme.colors.action.navigation.standard.highlight}`,
      },
    },
  }),
};
